import { useSubscription } from '@apollo/client';
import { useEffect, useState } from 'react';
import { SUBSCRIPTION_WORK_PACKAGES_IMPORT } from '@bechtel/client-gql';
import { ImportStatus } from '@bechtel/types';

export function useWorkPackagesImportSubscription() {
  const { data } = useSubscription<{ workPackagesImport: ImportStatus }>(SUBSCRIPTION_WORK_PACKAGES_IMPORT);
  const response = useState('');
  const setWorkPackageImportStatus = response[1];

  useEffect(() => {
    if (!data || !data.workPackagesImport || !data.workPackagesImport.status) {
      return;
    }
    setWorkPackageImportStatus(data.workPackagesImport.status);
  }, [data]);
  return response;
}
